import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { createUUID, sortMaterialResponse } from "@miplatform/utils";

export const useItemTemplatePlanAreaViewModel = ({ itemTemplate }) => {
  const [materials, setMaterials] = useState([]);
  const [isExpanded, setIsExpanded] = useState(true);

  const stateManager = useComponentState();
  const GET_MATERIALS_UUID = createUUID();

  const getMaterials = () => {
    stateManager.abort(GET_MATERIALS_UUID);
    stateManager.run(async () => {
      const itemTemplatesIds =
        itemTemplate?.planAreaMaterials?.map((m) => m.materialId) ?? [];
      const response = await homeService.materials.getAll({
        filters: { id: { in: { type: "guid", value: itemTemplatesIds } } },
      });
      if (response.status === HTTP_STATUSES.OK) {
        const sortedData = sortMaterialResponse(response.data);
        setMaterials(sortedData);
      }
    }, GET_MATERIALS_UUID);
  };

  return {
    materials,
    getMaterials,
    isExpanded,
    setIsExpanded,
    isLoading: stateManager.isBusy(),
  };
};
